import { atom } from 'recoil';

import { ISelectorTime } from '@shared/interfaces/timeSelector.interface';

export const bugoRegisterTimesAtom = atom<ISelectorTime | null>({
  key: 'bugoRegisterTimesAtom',
  default: null,
});
